module.exports = __webpack_public_path__ + "static/media/dbank.adca41d3.png";